import ReportSchedule from '../components/views/reportschedule/ReportSchedule.vue'
import ReportScheduleCreate from '../components/views/reportschedule/ReportScheduleCreate'
import ReportScheduleDetails from '../components/views/reportschedule/ReportScheduleDetails'
import SchedulesExpiry from '../components/views/dashboard/SchedulesExpiry'

const routes = [{
        path: 'report_settings',
        component: ReportSchedule,
        name: 'ReportSchedule',
        meta: {
            title: 'Report Schedules',
            requiresAuth: true
        }
    },

    {
        path: 'report_settings/create',
        component: ReportScheduleCreate,
        name: 'ReportScheduleCreate',
        meta: {
            title: ' Add Report Schedule',
            description: 'Add Report Schedule',
            requiresAuth: true
        }
    },
    {
        path: '/report_settings/:_id',
        beforeEnter: (to, from, next) => {
            to.params._id === 'create' ? next({ name: 'ReportScheduleCreate' }) : next()
        },
        component: ReportScheduleDetails,
        name: 'ReportScheduleDetails',
        meta: {
            description: 'Details for the selected Schedule',
            title: 'Update Schedule',
            requiresAuth: true
        }
    },
    {
        path: 'reportScheduleExpiry',
        component: SchedulesExpiry,
        name: 'SchedulesExpiry',
        meta: {
            title: 'Schedules Expiry',
            description: 'Reports Schedules expiry in 1 week'
        }
    }
]

export default routes


// WEBPACK FOOTER //
// ./src/routes/schedulereport.route.js